import { render, staticRenderFns } from "./player_edit.vue?vue&type=template&id=4d27a37a&scoped=true&"
import script from "./player_edit.vue?vue&type=script&lang=js&"
export * from "./player_edit.vue?vue&type=script&lang=js&"
import style0 from "./player_edit.vue?vue&type=style&index=0&id=4d27a37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d27a37a",
  null
  
)

export default component.exports